import { useContext, useEffect } from 'react';
import { Center, Loader, Stack } from '@mantine/core';

import AuthContext from 'context/AuthContext';
import { logger } from '../../utils/logger';

const LogoutPage = () => {
  const {
    actions: { logout },
  } = useContext(AuthContext);

  useEffect(() => {
    // Log user logout for audit trail
    logger.info('User logout initiated');
    
    logout();
    // Intentionally excluding logout function from dependencies as this effect should only
    // run once on component mount to perform logout action
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Center h="100vh">
      <Stack align="center">
        <Loader size="md" />
      </Stack>
    </Center>
  );
};

export default LogoutPage;
